import {useEffect} from "react";
import {Route, Routes} from "react-router-dom";
import SalesCategory from "../layout/salesCategory/SalesCategory"
import AddSalesCategory from "../layout/salesCategory/AddSalesCategory";

function SalesCategoryPage() {
  useEffect(() => {
    return() => {
      localStorage.removeItem("selectedId")
      localStorage.removeItem("itemOffset")
      localStorage.removeItem("forcePage")
    }
  }, []);

  return (
    <>
      <Routes>
        <Route path={"/"} element={<SalesCategory/>}/>
        <Route path={"/add"} element={<AddSalesCategory/>}/>
        <Route path={"/update/:id"} element={<AddSalesCategory/>}/>
      </Routes>
    </>
  )
}

export default SalesCategoryPage;